import React from "react";

const XLogo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.85">
        <path
          opacity="0.2"
          d="M3.75 3.75H7.5L20.25 20.25H16.5L3.75 3.75Z"
          fill="#FAFAFA"
          fillOpacity="0.84"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.182 3.43788C20.0599 3.17109 19.7934 3 19.5 3H18C17.782 3 17.5749 3.09482 17.4324 3.25979L12.4906 8.98183L8.09349 3.29141C7.95147 3.10762 7.7323 3 7.50003 3H3.75003C3.464 3 3.20288 3.16268 3.07681 3.41942C2.95074 3.67617 2.98168 3.98226 3.15656 4.20859L9.51098 12.4319L3.18239 19.7598C2.99062 19.9818 2.94594 20.2953 3.06804 20.5621C3.19015 20.8289 3.45661 21 3.75001 21H5.25001C5.46798 21 5.67516 20.9052 5.81763 20.7402L11.1552 14.5598L15.9066 20.7086C16.0486 20.8924 16.2678 21 16.5 21H20.25C20.5361 21 20.7972 20.8373 20.9232 20.5806C21.0493 20.3238 21.0184 20.0177 20.8435 19.7914L14.1349 11.1097L20.0676 4.24021C20.2594 4.01816 20.3041 3.70467 20.182 3.43788ZM5.2771 4.5L16.868 19.5H18.7224L7.13145 4.5H5.2771Z"
          fill="#FAFAFA"
          fillOpacity="0.84"
        />
      </g>
    </svg>
  );
};

export default XLogo;
